/**
 * Playready UUID.
 *
 * @group DRM
 *
 * @beta
 */
export const PLAYREADY_UUID = '9a04f079-9840-4286-ab92-e65be0885f95';
//# sourceMappingURL=PLAYREADY_UUID.js.map